import { QUESTIONS, type SvarMulighed } from '@/constants/questions';

export type { SvarMulighed };

export interface BeregnInput {
  budget: number;
  svar: Record<string, SvarMulighed>;
}

export interface BeregnResultat {
  lav: number;
  høj: number;
  /** Besparelse pr. spørgsmål (bruges til breakdown i ResultCard) */
  breakdown: Array<{
    key: string;
    title: string;
    lav: number;
    høj: number;
    /** true hvis bidraget er negativt (energi-advarsel) */
    erNegativ: boolean;
  }>;
}

/**
 * Beregner optimeringspotentiale på byggebudgettet.
 *
 * ⚠️  Ret ALDRIG beregningslogikken uden at spørge Morten først.
 *     Tallene er verificeret mod Matematikken_på_testen_v2.xlsx.
 */
export function beregnBesparelse(
  budget: number,
  svar: Record<string, SvarMulighed>
): BeregnResultat {
  let lav = 0;
  let høj = 0;

  const breakdown = QUESTIONS.map((q) => {
    const valg: SvarMulighed = svar[q.key] ?? 'ingenting';
    const [pctLav, pctHøj] = q.pct[valg];
    const bidragLav = q.andel * pctLav * budget;
    const bidragHøj = q.andel * pctHøj * budget;
    lav += bidragLav;
    høj += bidragHøj;
    return {
      key: q.key,
      title: q.title,
      lav: bidragLav,
      høj: bidragHøj,
      erNegativ: bidragLav < 0 || bidragHøj < 0,
    };
  });

  return { lav, høj, breakdown };
}
